import { Capacitor } from '@capacitor/core';

/**
 * Mendapatkan Public Base URL untuk e-katalog, QR meja, dan QR pelanggan.
 * Menangani kasus APK Capacitor/Cordova di mana window.location.origin adalah 'http://localhost'
 * atau 'capacitor://localhost' agar link yang digenerate selalu mengarah ke domain publik yang valid.
 */
export const getPublicBaseUrl = () => {
  // 1. Cek variabel environment eksplisit jika ada
  const envUrl =
    import.meta.env.VITE_ECATALOG_PUBLIC_BASE_URL ||
    import.meta.env.VITE_PUBLIC_WEB_URL ||
    import.meta.env.VITE_FRONTEND_URL;
  if (envUrl && typeof envUrl === 'string' && envUrl.trim() !== '') {
    return envUrl.trim().replace(/\/+$/, '');
  }

  // 2. Cek apakah berjalan di dalam environment lokal / native APK
  const origin = typeof window !== 'undefined' && window.location ? window.location.origin : '';
  const isLocalOrNative =
    !origin ||
    origin.includes('localhost') ||
    origin.includes('127.0.0.1') ||
    origin.startsWith('capacitor://') ||
    origin.startsWith('ionic://') ||
    origin.startsWith('file://') ||
    (typeof Capacitor !== 'undefined' && Capacitor.isNativePlatform && Capacitor.isNativePlatform());

  if (isLocalOrNative) {
    // Pada mode production atau bila API menembak ke server live asalink.id
    const apiUrl = import.meta.env.VITE_API_BASE_URL || '';
    if (apiUrl.includes('asalink.id') || import.meta.env.VITE_APP_ENV === 'production' || import.meta.env.PROD) {
      return 'https://pos.asalink.id';
    }
  }

  return origin || 'https://pos.asalink.id';
};

/**
 * Menormalisasi URL publik (misal URL QR meja atau QR pelanggan dari database backend)
 * Jika URL tersebut berawalan localhost atau scheme native APK (karena backend ter-generate dari origin APK),
 * maka host/origin-nya otomatis diganti dengan domain web publik yang benar.
 */
export const normalizePublicUrl = (rawUrl) => {
  if (!rawUrl || typeof rawUrl !== 'string') return '';
  const publicBase = getPublicBaseUrl();

  // Jika URL berupa path relatif (misal '/e-katalog/...')
  if (rawUrl.startsWith('/')) {
    return `${publicBase}${rawUrl}`;
  }

  try {
    const parsed = new URL(rawUrl);
    if (
      parsed.hostname === 'localhost' ||
      parsed.hostname === '127.0.0.1' ||
      parsed.protocol === 'capacitor:' ||
      parsed.protocol === 'ionic:' ||
      parsed.protocol === 'file:'
    ) {
      const targetBase = new URL(publicBase);
      parsed.protocol = targetBase.protocol;
      parsed.host = targetBase.host;
      return parsed.toString();
    }
    return rawUrl;
  } catch {
    return rawUrl;
  }
};
